module.exports = __webpack_public_path__ + "static/media/arrowRightLight.4c3ab669.svg";